import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component
export default class HybridButtonOne extends Vue {
    public title: string = 'HybridButtonOne';

    @Prop({ default: '#1380C3' })
    public backgroundColor: any;

    @Prop({ default: '#FFFFFF' })
    public color: any;

    @Prop({ default: null })
    public data: any;

    @Watch('data', { immediate: true, deep: true })
    public onDataInput(val: any, oldVal: any) {
    }
}
